export default __webpack_public_path__ + "static/media/promiseHand.48fc16d7.svg";